<script>
  import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle
  } from "sveltestrap";
  import { onMount } from "svelte";
  import { navigate, link } from "svelte-routing";
  import Icon from "svelte-awesome";
  import { signOut } from "svelte-awesome/icons";
  import axios from "axios";

  import LoadingPlaceholder from './LoadingPlaceholder.svelte';
  import { getMsalInstance } from "../msal-config.js";

  let msalInstance = null;

  let isOpen = false;
  let user = null;
  let name = "";
  let logo =
    window.location.origin + "/public/assets/images/SSI_logo_white.png";
  let menu = window.location.origin + "/public/assets/images/menu-bar.png";
  let isAdmin = false;
  let isCheckingAdmin = true;

  let navLinks = [
    { label: 'Timesheets', path: '/timesheet', hasAccess: () => true },
    { label: 'Job Board', path: '/board', hasAccess: () => true },
    { label: 'In Process', path: '/inprocess', hasAccess: () => !!JSON.parse(sessionStorage.getItem('is_admin')) },
    { label: 'Field Verification Schedule', path: '/fieldverification', hasAccess: () => true },
    { label: 'Reports', path: '/reports', hasAccess: () => (!!user && user.Type === 2) && !!JSON.parse(sessionStorage.getItem('is_admin')) },
  ]

  onMount(async () => {
    await initializeMFA();
    await getUser();
    checkIsAdmin();
  });

  async function initializeMFA() {
    msalInstance = await getMsalInstance();
    await msalInstance.initialize();
  }

  /** @deprecated DeliverableItems are now fetched from '/jobBoardV2Api/GetShownDeliverableItems' */
  function getDeliverable() {
    axios
      .get("/JobBoardApi/BuildDeliverables")
      .then(function(response) {
        const data = response.data.length - 1;
        localStorage.setItem("deliverables", data);
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  async function handleLogout() {
    logoutMFA();
    const res = await fetch("/authentication/logout");
    const json = await res.json();
    navigate("/Login", { replace: true });
    document.title = "Login";
    localStorage.removeItem("team");
    localStorage.removeItem("opened-cards");
    localStorage.removeItem("collapse");
    sessionStorage.removeItem('is_admin');
  }

  async function getUser() {
    const res = await fetch("/authentication/GetUserDetails");
    const json = await res.json();
    if (!json.Result) {
      await handleLogout();
      return;
    }

    user = json.Result;
    name = user.Name;
  }

  function FormatInitials(name) {
    const newname = name.charAt(0);
    return newname;
  }

  function checkIsAdmin() {
    if (!!JSON.parse(sessionStorage.getItem('is_admin')) && !!user) {
      isAdmin = true;
      isCheckingAdmin = false;
      navLinks = [...navLinks];
      return;
    }

    fetch(`/authentication/isadmin`)
      .then(response => response.json())
      .then(response => {
        isAdmin = response.Result;
        sessionStorage.setItem('is_admin', isAdmin);
        navLinks = [...navLinks];
        return;
      })
      .finally(_ => isCheckingAdmin = false);
  }

  function logoutMFA() {
    const logoutRequest = {
      account: msalInstance.getActiveAccount(),
      onRedirectNavigate: () => false
    };
    
    msalInstance.clearCache(logoutRequest);
  }
</script>

<style>
  .nav-ul ul {
    display: flex;
    list-style-type: none;
    margin-bottom: 0px;
    margin-top: 12px;
  }
  .nav-ul li {
    margin-left: 30px;
    color: white;
  }
  a {
    text-decoration: none;
    color: white;
  }
  .nav-logout {
    margin-left: auto;
    margin-top: 8px;
  }
  .menu-mobile-view {
    display: none;
  }
  @media (max-width: 768px) {
    .nav-logout {
      margin-top: 18px;
    }
  }
  @media (max-width: 426px) {
    .nav-ul {
      display: none;
    }
    .menu-mobile-view {
      display: block;
    }
    .mobile-view-bar {
      display: inline-block !important;
    }
  }
  .mobile-view-bar {
    display: none;
  }
</style>

<div class="nav-container">
  <div class="nav-logo">
    <img src={logo} alt="Timesheet" width="140px" />
  </div>
  <div class="nav-ul">
    <ul>
      {#if isCheckingAdmin}
        {#each navLinks as navLink}
          <li>
            <LoadingPlaceholder/>
          </li>
        {/each}
      {:else}
        {#each navLinks as navLink}
          {#if navLink.hasAccess()}
            <li>
              <a href="{navLink.path}"
                style={window.location.pathname === navLink.path ? 'font-weight: bold' : ''}>
                {navLink.label}
              </a>
            </li>
          {/if}
        {/each}
      {/if}
    </ul>
  </div>
  <div class="nav-logout">

    <Dropdown {isOpen} toggle={() => (isOpen = !isOpen)}>
      <DropdownToggle
        nav
        class="nav-logout-button"
        caret
        style=" color: #fff; padding: 0px; margin-right: 15px">
        <button class="profile-menu">
          {#if user !== null}
            <p style="margin: 6px; font-weight: bold">
              {FormatInitials(user.FirstName)}{FormatInitials(user.LastName)}
            </p>
          {/if}
        </button>
        <div class="mobile-view-bar">
          <img src={menu} alt="Menu bar" />
        </div>
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem style="color: #3498DB; font-weight: bold;" disabled>
          {name}
        </DropdownItem>
        <DropdownItem href="/requestPTO">Request PTO</DropdownItem>
        <DropdownItem divider />
        <div class="menu-mobile-view">
          <DropdownItem href="/timesheet">Timesheet</DropdownItem>
          <DropdownItem divider />
          <DropdownItem href="/board">Job board</DropdownItem>
          <DropdownItem divider />
          <DropdownItem href="/inprocess">In Process</DropdownItem>
          <DropdownItem divider />
          <DropdownItem href="/fieldverification">
            Field Verification
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem href="/reports">Reports</DropdownItem>
          <DropdownItem divider />

        </div>
        <DropdownItem on:click={handleLogout}>
          <Icon data={signOut} />
          Logout
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</div>
<div class="sub-nav-container">
  <slot></slot>
</div>
